<template>
  <tbody class="rc-table__tbody">
    <template v-if="tableData && tableData.length">
      <tr v-for="(dataItem, dataIndex) in tableData" :key="'tr_' + dataIndex">
        <td
          v-for="(item,index) in columns"
          :key="'tr_' + dataIndex + '-td_'+index"
          :class="{ 'is-center': getAttrs(item).align === 'center' }"
          class="rc-table__tbody-cell">
          <div class="rc-table__cell">
            <scoped-slot v-if="item.data.scopedSlots" :render-node="item.data.scopedSlots.default(dataItem)"/>
            <template v-else>{{ getPropByPath(dataItem, getAttrs(item).prop).v }}</template>
          </div>
        </td>
      </tr>
    </template>
    <template v-else>
      <tr>
        <td :colspan="columns.length" class="rc-table__tbody-cell is-center rc-table__empty">暂无数据</td>
      </tr>
    </template>
  </tbody>
</template>
<script type="text/ecmascript-6">
import { getPropByPath } from './util'
import getParentInfo from './getParentInfo'
import scopedSlot from './scopedSlot'

export default {
  name: 'TableBody',
  components: {
    scopedSlot
  },
  mixins: [getParentInfo],
  methods: {
    getPropByPath
  }
}
</script>
